'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Loader = require('./Loader.scss');

var _Loader2 = _interopRequireDefault(_Loader);

var _reactRedux = require('react-redux');

var _Loader3 = require('./Loader');

var _Loader4 = _interopRequireDefault(_Loader3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  MainLoader: {
    displayName: 'MainLoader'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Loader/MainLoader.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var MainLoader = _wrapComponent('MainLoader')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loading: state.loader.loading
  };
}), _dec2 = (0, _reactCssModules2.default)(_Loader2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MainLoader, _Component);

  function MainLoader() {
    (0, _classCallCheck3.default)(this, MainLoader);
    return (0, _possibleConstructorReturn3.default)(this, (MainLoader.__proto__ || (0, _getPrototypeOf2.default)(MainLoader)).apply(this, arguments));
  }

  (0, _createClass3.default)(MainLoader, [{
    key: 'render',
    value: function render() {
      return _react3.default.createElement(
        'div',
        { className: 'main-loader-container', styleName: this.props.loading ? 'loader-container' : 'loader-container-hide' },
        _react3.default.createElement(_Loader4.default, null)
      );
    }
  }]);
  return MainLoader;
}(_react2.Component), _class2.propTypes = {
  loading: _react2.PropTypes.bool
}, _temp)) || _class) || _class));

exports.default = MainLoader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/MainLoader.js
// module id = 1555
// module chunks = 47